(function ($) {
    /**
     * Plugin jQuery dsBadge pour créer et gérer des badges dynamiques
     * @param {Object} options - Options de configuration du badge
     * @param {string|number|boolean} [options.value] - Valeur du badge (true pour badge vide, nombre pour valeur numérique)
     * @param {string} [options.message] - Message accessible pour le badge
     * @param {boolean} [options.large=false] - Indique si le badge doit être grand
     */
    $.fn.dsBadge = function (options) {
        // Configuration par défaut
        const settings = $.extend(true, {
            label: null,
            message: null
        }, options || {});

        // Fonction pour générer un UUID (identique à celle du plugin uploadButton)
        function uuid() {
            return 'xxxxyxxx'.replace(/[xy]/g, function (c) {
                let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }

        // Fonction pour formater le label du badge
        function formatLabel(value) {
            if (!value) {
                return value;
            }
            if (typeof value === 'number' || !isNaN(value)) {
                return value > 99 ? '99+' : String(value);
            }
            return String(value);
        }

        return this.each(function () {
            const $element = $(this);
            let label;
            let message;
            let $badge;

            // Vérifier si l'élément est un badge ou contient un badge
            if ($element.hasClass('a-badge')) {
                $badge = $element;
            } else {
                $badge = $element.find('.a-badge').first();
            }

            // Si badge déjà initialisé, ne rien faire
            if ($badge.data('dsBadge')) {
                return;
            }

            let uuidValue = uuid();
            let badgeId = $badge.attr('id') || `badge-${uuidValue}`;
            let removeOnDestroy = true;

            // Si le badge n'existe pas, le créer
            if ($badge.length === 0) {
                label = $element.data('ds-badge-label') || settings.label;
                message = $element.data('ds-badge-message') || settings.message;
                $badge = $(`
                    <span class="a-badge${label ? ' a-badge--large' : ''}" id="${badgeId}" role="status">
                        ${label ? `<span class="a-badge__label">${formatLabel(label)}</span>` : ''} 
                        ${message ? ` <span class="sr-only">${message}</span>` : ''}
                    </span>
                `);
                
                // Ajouter le badge à l'élément
                $element.append($badge);

                // Ajouter la classe has-badge à l'élément parent si nécessaire
                if (!$element.hasClass('has-badge')) {
                    $element.addClass('has-badge');
                }
            } else {
                label = $badge.find('a-badge__label').text() || null;
                message = $badge.find('sr-only').text() || null;
                removeOnDestroy = false;

                if (!$badge.attr('id')) {
                    // Si le badge existe mais n'a pas d'ID, lui en ajouter un
                    $badge.attr('id', badgeId);
                }

                if (!$badge.attr('role')) {
                    // Si le badge existe mais n'a pas d'attribut role
                    $badge.attr('role', 'status');
                } else if ($badge.attr('role') !== 'status' && !$badge.attr('aria-live')) {
                    $badge.attr('aria-live', 'polite');
                    $badge.attr('aria-atomic', 'true');
                }

                // Ajouter la classe has-badge à l'élément parent si nécessaire
                if ($element.parent().length && !$element.parent().hasClass('has-badge')) {
                    $element.parent().addClass('has-badge');
                }
            } 

            // Memoire interne du composant badge
            let state = {
                uuid: uuidValue,
                label,
                message,
                removeOnDestroy
            };

            // API publique
            $badge.data('dsBadge', {
                /**
                 * Met à jour la valeur et le message du badge
                 * @param {string|number|boolean} label - Nouveau label du badge
                 * @param {string} message - Nouveau message accessible
                 */
                update: function (label, message) {
                    if (!state) return;

                    $badge.find('.a-badge__label').remove();
                    const formattedLabel = formatLabel(label);
                    if (formattedLabel) {
                        $badge.append(`<span class="a-badge__label">${formattedLabel}</span>`);
                    }
                    $badge.find('.sr-only').text(message || '');
                    state.label = label;
                    state.message = message;
                },

                /**
                 * Met à jour uniquement le label du badge
                 * @param {string|number|boolean} label - Nouveau label du badge
                 */
                setLabel: function (label) {
                    if (!state) return;

                    $badge.find('.a-badge__label').remove();
                    const formattedLabel = formatLabel(label);
                    if (formattedLabel) {
                        $badge.append(`<span class="a-badge__label">${formattedLabel}</span>`);
                    }
                    state.label = label;
                },

                /**
                 * Met à jour uniquement le message accessible
                 * @param {string} message - Nouveau message accessible
                 */
                setMessage: function (message) {
                    if (!state) return;

                    $badge.find('.sr-only').text(message || '');
                    state.message = message;
                },

                /**
                 * Récupère le label du badge
                 * @returns {string} label du badge
                 */
                getLabel: function () {
                    if (!state) return;

                    return state.label;
                },

                /**
                 * Récupère le message accessible actuel
                 * @returns {string} Message accessible actuel
                 */
                getMessage: function () {
                    if (!state) return;

                    return state.message;
                },

                /**
                 * Détruit le badge et le supprime du DOM
                 */
                destroy: function () {
                    if (!state) return;

                    // Supprimer les element ajouter au DOM
                    const badgeId = $badge.attr('id');
                    if (state.removeOnDestroy) {
                        $badge.remove();
                    } else if (badgeId && badgeId.contains(state.uuid)) {
                        $badge.removeAttr('id');
                    }

                    // Supprimer les données associées
                    $badge.removeData('dsBadge');

                    // Réinitialiser l'état
                    state = null;
                }
            });
        });
    };
})(jQuery);